import { TransactionType } from 'src/type/transaction';

export const tradeTxTypeOptions = [
  {
    label: 'ทุกประเภท',
    value: 'all',
  },
  {
    label: 'ซื้อ',
    value: TransactionType.BUY,
  },
  {
    label: 'ขาย',
    value: TransactionType.SELL,
  },
];

export const txAction = (type: TransactionType) => {
  switch (type) {
    case TransactionType.BUY:
      return 'ซื้อ';
    case TransactionType.SELL:
      return 'ขาย';
    default:
      throw new Error('Invalid transaction type');
  }
};
